import React, { SetStateAction, useEffect, useState } from "react";
import Th from "../../common/Th";
import Table from "../../common/Table";
import Field from "../../common/Field";
import {
    useTextField,
    useRadioField,
    useSelectField,
    useForm,
    usePhoneField,
    Antecedente,
} from "../../common/Form";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import { formatRut, validateRut } from "../../utils/rut";
import { formatPassport, validatePassport } from "../../utils/passport";
import { validateEmail } from "../../utils/email";
import axios from "axios";
import _ from "lodash";
import { maxTitulos, useTitulosField } from "../../common/titulos";
import { useParams } from "react-router-dom";
import Request from "../../common/Request";
import Grid from "@material-ui/core/Grid";
import { objectToFormData } from "object-to-formdata";
import { editPostulacionSuccess, postulacionSuccess } from "../../utils/popups";
import { Attachment, FileField } from "../../common/attachments";
import { List } from "immutable";
import {
    allowedExtensions,
    PostulacionAttachment,
    PostulacionFileField,
} from "./attachments";
import { AntecedenteDefault } from "../admin-concursos/Mantenedor";
import {
    handlePostulacionError,
    handlePostularError,
    handleServerError,
} from "../../utils/errors";
import { number } from "prop-types";

type SectionProps = {
    header: string;
};

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
}));

const Section: React.FC<SectionProps> = (props) => {
    return (
        <div className="mb-3">
            <div
                style={{
                    backgroundColor: "#18528A",
                    color: "white",
                    paddingTop: "0.25em",
                    paddingLeft: "0.5em",
                    paddingBottom: "0.25em",
                }}
            >
                {props.header}
            </div>
            {props.children}
        </div>
    );
};

const Label: React.FC = (props) => {
    return (
        <div
            style={{
                width: "8em",
                display: "inline-block",
            }}
        >
            {props.children}
        </div>
    );
};

const Value: React.FC = (props) => {
    return <span>{props.children}</span>;
};

type InputFileProps = {
    label: string;
};

const InputFile: React.FC<InputFileProps> = (props) => {
    return (
        <div
            style={{
                backgroundColor: "white",
                borderStyle: "solid",
                borderColor: "gray",
                borderWidth: 1,
                borderRadius: "0.5em",
                paddingTop: "0.25em",
                paddingLeft: "0.5em",
                paddingRight: "0.5em",
                paddingBottom: "0.5em",
                marginBottom: "3em",
            }}
        >
            <div style={{ marginBottom: "0.25em" }}>{props.label}</div>
            <div
                style={{
                    fontSize: `${9 / 11}em`,
                    marginBottom: "2em",
                }}
            >
                Campo requerido
            </div>
            <input type="file" />
            <button>Adjuntar Archivo</button>
        </div>
    );
};

type Nacionalidad = {
    id: number;
    nombre: string;
};

type Postulacion = {
    tipo_documento: string;
    id: number;
    id_nacionalidad: string;
    id_pais_residencia: string;
    concurso: number;
    codigo: string;
    correo: string;
    telefono: string;
    nombres: string;
    apellidos: string;
    rut_pasaporte: string;
    direccion: string;
    titulos: {
        id: number;
        titulo: string;
        institucion: string;
    };
    antecedentes: {
        id: number; // este es el que se le pasa a downloadFilePostulacion
        postulacion: number;
        antecedente: number;
        archivo: number;
    }[];
};

type PostulacionFormType = {
    concursoPk: string | number;
    defaultData?: Postulacion;
    popUp?: boolean;
    uuid?: string;
};

const PostulacionForm: React.FC<PostulacionFormType> = (props) => {
    const classes = useStyles();
    const concursoPk = props.concursoPk;
    const [concurso, setConcurso] = useState<any>({});
    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(true);
    const [clicked, setClicked] = useState(false);
    const [getConcursoError, setGetConcursoError] = useState(false);
    const [getNacionalidadesError, setGetNacionalidadesError] = useState(false);
    const [openSpinner, setOpenSpinner] = useState(false);
    const defaultData = props.defaultData;
    const [msje, setMsje] = useState("");
    function getCorreoContacto() {
        return concurso.correo_contacto
    }

    useEffect(() => {
        setLoading(true);
        axios
            .get(`${(window as any).ENV.API_URL}/datosConcurso/${concursoPk}/`)
            .then((response) => setConcurso(response.data))
            .catch((error) => {
                setGetConcursoError(true);
                handlePostulacionError(error);
            })
            .finally(() => setLoading(false));
    }, [concursoPk]);

    // cargar nacionalidades del backend
    const [nacionalidades, setNacionalidades] = useState<Nacionalidad[]>([]);
    useEffect(() => {
        if (!getConcursoError) {
            setLoading2(true);
            axios
                .get((window as any).ENV.API_URL + "/nacionalidades/")
                .then((response) => {
                    let nacionalidades = response.data;
                    // las nacionalidades del backend no vienen ordenadas
                    nacionalidades = _.sortBy(nacionalidades, "nombre");
                    nacionalidades = nacionalidades.filter((nac) => nac.id > 0);
                    let cl = nacionalidades.find((nac) => nac.nombre === "Chile");
                    let clIndex = nacionalidades.indexOf(cl);
                    nacionalidades.splice(clIndex, 1);
                    // que salga chile al principio
                    nacionalidades = [cl, ...nacionalidades];
                    setNacionalidades(nacionalidades);
                })
                .catch((error) => {
                    setGetNacionalidadesError(true);
                    handleServerError();
                })
                .finally(() => setLoading2(false));
        }
    }, []);

    // form datos personales

    const nombresField = useTextField({
        label: "Nombres",
        fullWidth: true,
        defaultValue: defaultData ? defaultData.nombres : "",
    });
    const apellidosField = useTextField({
        label: "Apellidos",
        fullWidth: true,
        defaultValue: defaultData ? defaultData.apellidos : "",
    });
    const correoField = useTextField({
        label: "Email",
        fullWidth: true,
        defaultValue: defaultData ? defaultData.correo : "",
        validate: validateEmail,
    });
    const telefonoField = usePhoneField({
        label: "Teléfono",
        defaultValue: defaultData ? defaultData.telefono : "",
    });

    const direccionField = useTextField({
        label: "Dirección de Residencia",
        fullWidth: true,
        defaultValue: defaultData ? defaultData.direccion : "",
    });

    const nacionalidadField = useSelectField({
        label: "Nacionalidad",
        defaultValue: defaultData ? defaultData.id_nacionalidad : "",
        options: nacionalidades.map((nac) => ({
            value: nac.id.toString(),
            label: nac.nombre,
        })),
    });

    const paisResidenciaField = useSelectField({
        label: "Pais de Residencia",
        defaultValue: defaultData ? defaultData.id_pais_residencia : "",
        options: nacionalidades.map((nac) => ({
            value: nac.id.toString(),
            label: nac.nombre,
        })),
    });

    const rutPasaporteField = useRadioField({
        label: "Tipo de documento",
        name: "rut_pasaporte",
        defaultValue: defaultData ? defaultData.tipo_documento : "",
        options: [
            { value: "rut", label: "Rut" },
            { value: "pasaporte", label: "Pasaporte" },
        ],
    });

    const numDocumentoField = useTextField({
        label: "Número de documento",
        defaultValue: defaultData ? defaultData.rut_pasaporte : "",
        fullWidth: true,
        ...(rutPasaporteField.value === "rut"
            ? {
                validate: validateRut,
                format: formatRut,
            }
            : rutPasaporteField.value === "pasaporte"
                ? {
                    validate: validatePassport,
                    format: formatPassport,
                }
                : {
                    validate: () => "Seleccione arriba el tipo de documento",
                }),
    });

    const datosPersonalesForm = useForm([
        nombresField,
        apellidosField,
        correoField,
        telefonoField,
        rutPasaporteField,
        numDocumentoField,
        nacionalidadField,
        direccionField,
        paisResidenciaField,
    ]);

    const titulosField = useTitulosField({
        defaultValue: defaultData ? defaultData.titulos : null,
    });
    const titulosForm = useForm([titulosField]);

    const postulacion = {
        concurso: concursoPk,
        id_nacionalidad: nacionalidadField.value,
        id_pais_residencia: paisResidenciaField.value,
        correo: correoField.value,
        telefono: telefonoField.value,
        rut_pasaporte: numDocumentoField.value,
        nombres: nombresField.value,
        apellidos: apellidosField.value,
        tipo_documento: rutPasaporteField.value,
        direccion: direccionField.value
    };

    const enviarPostulacion = React.useCallback(() => {
        //showSpinner();
        setOpenSpinner(true)
        setClicked(true)
        console.log(postulacion);
        const json = {
            concurso: postulacion.concurso,
            id_nacionalidad: postulacion.id_nacionalidad,
            id_pais_residencia: postulacion.id_pais_residencia,
            correo: postulacion.correo,
            telefono: postulacion.telefono,
            rut_pasaporte: postulacion.rut_pasaporte,
            nombres: postulacion.nombres,
            apellidos: postulacion.apellidos,
            tipo_documento: postulacion.tipo_documento,
            direccion: postulacion.direccion
        };

    


        const formObj = {
            postulacion: json,
            titulos: titulosField.value.toArray(),
            antecedentes: attachments
                .map((attachment) => ({
                    antecedente: attachment.antecedente.id,
                    archivo: attachment.archivo,
                }))
                .toArray(),
        };
        console.log("_________________________")
        console.log(JSON.stringify(formObj))
        const options = {
            indices: true,
            nullsAsUndefineds: false,
            booleansAsIntegers: false,
            allowEmptyArrays: false,
        }
        const formData = objectToFormData(formObj, options);
        const config = {
            headers: {
                "content-type": "multipart/form-data",
            },
        };

        if (defaultData) {
            axios
                .put(
                    (window as any).ENV.API_URL + "/postulacion/" + props.uuid + "/",
                    formData,
                    config
                )
                .then((res) => {
                    //hideSpinner("success");
                    setOpenSpinner(false)
                    setTimeout(() => {
                        editPostulacionSuccess(postulacion.correo);
                    }, 1000);
                })
                .catch((error) => {
                    setOpenSpinner(false)
                    setClicked(false);
                    handlePostularError(error, getCorreoContacto());
                });
        } else {
            axios
                .post((window as any).ENV.API_URL + "/postulacion/", formData, config)
                .then((res) => {
                    //hideSpinner("success");
                    setOpenSpinner(false)
                    setTimeout(() => {
                        postulacionSuccess(postulacion.correo);
                    }, 1000);
                })
                .catch((error) => {
                    //hideSpinner("error");
                    setOpenSpinner(false)
                    setClicked(false);
                    handlePostularError(error, getCorreoContacto());
                });
        }
    }, [postulacion]);

    // adjuntar antecedentes
    const [attachments, setAttachments] = useState(List<PostulacionAttachment>());

    useEffect(() => {
        if (attachments.isEmpty() && concurso.antecedentes != null) {
            setAttachments(
                List<PostulacionAttachment>(
                    (concurso.antecedentes ?? []).map(
                        (antecedenteConcurso: AntecedenteDefault) =>
                            new PostulacionAttachment({
                                id:
                                    defaultData?.antecedentes /* postulacion */
                                        ?.find(
                                            (antecedentePostulacion) =>
                                                antecedentePostulacion.antecedente ===
                                                antecedenteConcurso.id &&
                                                antecedentePostulacion.archivo != -1
                                        )?.id ?? -1,
                                nombre: antecedenteConcurso.nombre,
                                archivo: null,
                                reactKey: antecedenteConcurso.id.toString(),
                                deleted: false,
                                antecedente: antecedenteConcurso,
                            })
                    )
                )
            );
        }
       let suma : number = 0 
        for (let i = 0; i < attachments.size; i++) {
            if (attachments?.get(i)?.archivo?.size) {
            suma +=    attachments?.get(i)?.archivo?.size ?? 0;
            }
        } 
        if ((suma/ 1048576)>20){
            const mb = (suma / 1048576).toFixed(2);
          setMsje("La suma del tamaño de los archivos debe ser menor o igual a 20MB, usted tiene "+ mb+"MB");  
        }else{
            setMsje("")
        }
        
    }, [attachments, concurso.antecedentes]);

    function updateAttachment(
        index: number,
        action: SetStateAction<PostulacionAttachment>
    ): void {
        if (typeof action === "function") {
            const resp=(list) => list.update(index, action);
            setAttachments(resp);
        } else {
            setAttachments((list) => list.set(index, action));
        }
    }

    function form() {
        if (clicked === true) {
            return true
        }
        let formsAreValid = true
        if (datosPersonalesForm.isValid &&
            titulosField.value.size > 0) {
            formsAreValid = false
            attachments.forEach(element => {
                if (element.antecedente.obligatorio == '1') {
                    formsAreValid = !element.isValid
                }

            });
        }
        if (msje!=""){
            return true;
        }
        //validar suma

        return formsAreValid
    }

    // render
    return (
        <div className="d-flex justify-content-center">
            <Request
                action="obtener los datos de"
                resource="el concurso al que desea postular"
                loading={loading || loading2}
                err={getNacionalidadesError || getConcursoError}
            >
                <div style={{ maxWidth: "50em" }}>
                    <div
                        className="py-3"
                        style={{
                            backgroundColor: "white",
                            color: "#18528A",
                            borderColor: "gray",
                            borderWidth: 1,
                        }}
                    >
                        <span style={{ fontSize: "17px", color: "#aaa" }}>
                            {concurso.nombre_facultad}
                        </span>
                        <h5>{concurso.nombre}</h5>
                    </div>

                    <Section header="Datos Contacto">
                        <div className="p-2">
                            <Label>Nombre</Label>
                            <Value>{concurso.nombre_contacto}</Value>
                        </div>
                        <div className="p-2">
                            <Label>Correo</Label>
                            <Value>{concurso.correo_contacto}</Value>
                        </div>
                    </Section>

                    <Section header="Datos Personales">
                        <Grid container>
                            <Grid container justify="space-between" spacing={3}>
                                <Grid item xs={6}>
                                    <Field>{nombresField.render()}</Field>
                                </Grid>
                                <Grid item xs={6}>
                                    <Field>{apellidosField.render()}</Field>
                                </Grid>
                            </Grid>
                            <Grid container justify="space-between" spacing={3}>
                                <Grid item xs={6}>
                                    <Field>{correoField.render()}</Field>
                                </Grid>
                                <Grid item xs={6}>
                                    <Field>{telefonoField.render()}</Field>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Field>{nacionalidadField.render()}</Field>
                            </Grid>
                            <Grid container justify="space-between" spacing={3}>
                                <Grid item>
                                    <Field>{rutPasaporteField.render()}</Field>
                                </Grid>
                                <Grid item xs={true}>
                                    <Field>{numDocumentoField.render()}</Field>
                                </Grid>
                            </Grid>
                            {rutPasaporteField.value === "rut" ? (
                                <small>
                                    Ingrese el número de documento sin puntos y con guión. Ej:
                                    12345678-9
                                </small>
                            ) : rutPasaporteField.value === "pasaporte" ? (
                                <small>
                                    Ingrese el número de documento anteponiendo una P. Ej:
                                    P12345678
                                </small>
                            ) : null}
                            <Grid item xs={12}>
                                <Field>{paisResidenciaField.render()}</Field>
                            </Grid>
                            <Grid item xs={12}>
                                <Field>{direccionField.render()}</Field>
                            </Grid>
                        </Grid>
                    </Section>

                    <Section header={`Título/Grado (hasta ${maxTitulos} permitidos)`}>
                        {titulosField.render()}
                    </Section>

                    <Section header="Antecedentes requeridos">
                        <div
                            style={{
                                fontSize: `${9 / 11}em`,
                                marginBottom: "2em",
                            }}
                        >
                            Archivos permitidos:{" "}
                            {allowedExtensions.map((e) => e.extension).join(", ")}. La suma del tamaño de los archivos debe ser menor a 20MB.
                        </div>

                        <div
                            style={{
                            fontSize: `${10 / 11}em`,
                            marginBottom: "2em",
                            color: "red"
                            }}
                        >
                            {msje}
                        </div>

                        {attachments.map((attachment, index) => (
                            <PostulacionFileField
                                key={attachment.reactKey}
                                attachment={attachment}
                                setAttachment={(action) => updateAttachment(index, action)}
                                isEditing={defaultData != null}
                            />
                        ))}
                    </Section>

                    <div className="py-4 d-flex justify-content-center">
                        <Button
                            variant="contained"
                            color="primary"
                            disableElevation
                            disabled={form()}
                            onClick={enviarPostulacion}
                        >
                            Postular
                        </Button>
                    </div>
                </div>
                <Backdrop className={classes.backdrop} open={openSpinner}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Request>
        </div>
    );
};

export default PostulacionForm;
